updateCartStuff();

function showCart() {
  if ($('#cart').length == 0) {
    $('.cart-overlay').addClass('show');
    $('body').addClass('cart-open');
    $('.cart-items').addClass('open');
  }
}

function addItem(form_id) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: $('#' + form_id).serialize(),
    success: function(product) {
      updateCartStuff();
      showCart();
    },
    error: function(obj, status) {
      alert('The product you are trying to add is out of stock.');
    }
  });
}

function cartSubtract(variant_id, qty) {

  var newQty = qty - 1;
  var data = 'updates[' + variant_id + ']=' + newQty;

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(cart) {
      updateCartStuff();
      showCart();
    },
    error: function() {
      alert('There was an error.');
    }
  });

}

function cartAdd(variant_id, qty) {

  var newQty = qty + 1;
  var data = 'updates[' + variant_id + ']=' + newQty;

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(cart) {
      updateCartStuff();
      showCart();
    },
    error: function() {
      alert('There was an error.');
    }
  });

}

function cartRemove(variant_id) {

  var data = 'updates[' + variant_id + ']=0';

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(cart) {
      updateCartStuff();
      showCart();
    },
    error: function() {
      alert('There was an error.');
    }
  });

}

function cartNotes(note) {
    var notes = $.trim(note);
    var data = 'note=' + notes;
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(cart) {
          console.log(notes);
        },
        error: function() {
          alert('There was an error.');
        }
    });
}

function updateCartStuff() {

  $.ajax({

    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {

      $('.cart-items .items').html('');

      $('.cart-items .checkout .total_price').html((Shopify.formatMoney(cart.total_price)).replace('.00', ''));

      if (cart.item_count > 0) {

        $.each(cart.items, function(index, cartItem) {

          var item = '';

          item += '<div class="flex item">';

          item += '<div class="col">';
          item += '<img src="' + cartItem.image + '" alt="' + cartItem.title + '" title="' + cartItem.title + '" />';
          item += '</div>';

          item += '<div class="col two flex column space-between">';
          item += '<a href="' + cartItem.url + '" class="name canela-font">' + cartItem.product_title + '</a>';
          item += '<div class="options europa-regular-font">'
          if( cartItem.variant_title ) { item += '<div class="option">' + cartItem.variant_title + '</div>'}
          if( cartItem.properties ) { item += '<p class="gift-wrapped-prop europa-bold-font pink-color">Gift Wrapped</p>'  }       
          item += '</div>';
          item += '<div class="quantity europa-regular-font off-white-bg">';
          item += '<span class="subtract" onclick="cartSubtract(' + cartItem.variant_id + ', ' + cartItem.quantity + '); return false;">-</span>' + cartItem.quantity + '<span class="add" onclick="cartAdd(' + cartItem.variant_id + ', ' + cartItem.quantity + '); return false;">+</span>';
          item += '</div>';          
          item += '</div>';

          item += '<div class="col half flex column space-between">';
          item += '<div class="remove text-right" onclick="cartRemove(' + cartItem.variant_id + '); return false;">x</div>';
          item += '<div class="price europa-regular-font text-right">' + (Shopify.formatMoney(cartItem.price).replace('.00', '')) + '</div>';
          item += '</div>';

          item += '</div>';

//                     console.log(cartItem);


          $('.cart-items .items').prepend(item);

        });
        
        $('.cart-items .gift-message textarea').val(cart.note);

        if ($('.cart-items .item .variant').length) {
          $('.cart-items .item .variant').each(function() {
            if ($(this).text().indexOf('null') >= 0) {
              $(this).hide();
            }
          })
        }

        $('.cart-items .checkout').show(0);

      } else {

        $('.cart-items .items').append('<div class="center-text" style="padding-top: 42px; border-top: 2px solid black;">Your cart is empty.</div>');

        $('.cart-items .checkout').hide(0);

      }

      $('.count').html(cart.item_count);

    }

  });

}

if ($('.quantity').length) {

    $('.add').on('click', function() {
      $(this).prev().val(function(i, oldval) {
        return ++oldval;
      });
    })
    $('.subtract').on('click', function() {
      $(this).next().val(function(i, oldval) {
        if (oldval > 1) {
          return --oldval;
        } else {
          return oldval
        }
      });
    })    

}